import { inlineObjectFieldStyles } from 'app/components/DataEntry/Form';

export const form_styles = {
  form: {
    formWidth: '800px',
    container: { pl: 4 },
  },
  objectField: {
    ...inlineObjectFieldStyles,
    propertyContainer: { w: '50%' },
  },
};
